import { useGetIdentity, useTranslate } from 'react-admin';
import { Card, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useRevenueCat } from '../../payWall/RevenueCatProvider';
import { LandingAppFeature } from './LandingAppFeature';
import { GetStartedButton } from './GetStartedButton';
import { ComparePlansButton } from '../../components/pay-wall/ComparePlansButton';


const blobStorage = 'https://estatetime.blob.core.windows.net/root/web/landing/';
const videoUrl = `${blobStorage}video.mp4`;

const Video = () => (
  <video
    autoPlay
    loop
    muted
    className="video-background"
    style={{ height: '100%', width: '80%', objectFit: 'cover' }}
  >
    <source src={videoUrl} type="video/mp4" />
    <img src={`${blobStorage}video_ph.jpg`} alt="Main" style={{ width: '1280px', height: '100%', objectFit: 'cover' }} />
  </video>
);

export const LandingPage = () => {
  const translate = useTranslate();
  const { identity, isLoading: identityLoading } = useGetIdentity();
  const { customerInfo } = useRevenueCat();

  return (
    <Card sx={{ p: 4, pt: 8, }}>
      <Box display="flex" maxWidth={'100%'} flexDirection='column' gap={1}>
        <Typography sx={styles.pageTitle} gutterBottom>
          {'REAL ESTATE MADE SIMPLE'}
        </Typography>
        <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' gap={2}>
          <Typography sx={styles.sectionTitle} gutterBottom>
            {'Your Partner in Real Estate'}
          </Typography>
          <Box flexDirection='row' display='flex' gap={2}>
            <Box flexDirection='row' display='flex' gap={2}>
              {!identityLoading && !(identity?.id) && (
                <GetStartedButton />
              )}
              <ComparePlansButton />
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Video />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 4 }}>
        <LandingAppFeature
          image={`${blobStorage}1.jpg`}
          title={'ABOUT OUR TOOL'}
          description={'MyRealStat is the go-to solution for real estate market insights and analysis. Our innovative tool is crafted by a team of data enthusiasts, real estate experts, and tech innovators to empower buyers, sellers, investors, and professionals in making informed decisions.'}
          position='left'
        />
        <LandingAppFeature
          image={`${blobStorage}2.jpg`}
          title={'Easily Map The Most Relevant Attributes'}
          description={'Access exclusive Single Family Homes Sales and Rental Data. Easily map the most relevant statistical data to analyze historical changes in real estate sales and identify next investment opportunities.'}
          position='right'
        />
        <LandingAppFeature
          image={`${blobStorage}3.jpg`}
          title={'Identify Next Investment Opportunities'}
          description={'A wide set of attributes designed specifically for investors can be utilized to find the areas exhibiting potential investment opportunities, either current or in the future.'}
          position='left'
        />
      </Box>
    </Card>
  );
};

const styles = {
  pageTitle: { typography: 'h3' },
  sectionTitle: { typography: 'h6' },
};